import React from "react";
import { Phone, Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND } from "@/lib/brand";
import { SERVICE_KEYS } from "@/i18n";
import { TID } from "@/constants/testIds/dv";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid={TID.footer}
      className="relative bg-[#050505] text-white pt-20 pb-10 overflow-hidden"
    >
      {/* Watermark */}
      <div className="absolute -bottom-10 left-0 right-0 overflow-hidden pointer-events-none select-none">
        <div className="watermark-text text-center whitespace-nowrap">DV SOLUTIONS</div>
      </div>

      <div className="relative container-x">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <img src={BRAND.logo} alt="DV Solutions" className="h-14 w-auto" />
            <div className="mt-4 font-display uppercase text-2xl tracking-tight">
              DV Solutions Inc.
            </div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#E63946] font-semibold">
              {t("footer.tagline")}
            </div>
            <p className="mt-4 text-sm text-white/60 max-w-md leading-relaxed">
              {t("about.p1")}
            </p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">
              {t("footer.services_title")}
            </div>
            <ul className="space-y-2 text-sm">
              {SERVICE_KEYS.map((k) => (
                <li key={k}>
                  <a
                    href="#services"
                    className="text-white/80 hover:text-[#E63946] transition-colors"
                  >
                    {t(`services.items.${k}.name`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">
              {t("footer.contact_title")}
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={BRAND.phoneHref}
                  className="flex items-center gap-2 text-white/85 hover:text-[#E63946]"
                >
                  <Phone className="h-4 w-4 text-[#E63946]" /> {BRAND.phone}
                </a>
              </li>
              <li>
                <a
                  href={BRAND.emailHref}
                  className="flex items-center gap-2 text-white/85 hover:text-[#E63946] break-all"
                >
                  <Mail className="h-4 w-4 text-[#E63946]" /> {BRAND.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <div>
            © {year} DV Solutions Inc. {t("footer.rights")}
          </div>
          <div className="uppercase tracking-[0.2em]">{t("footer.built_with_care")}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
